const renderCustomerComponent = (customer) => (
  <div className='flex flex-col gap-1'>
    <p className='font-bold text-sm'>{customer.name}</p>
    {/* <p className='font-medium text-xs text-blue-secondary'>{customer.club_name}</p> */}
  </div>
)

const TYPE_TEXT_COLOR = {
  REGULAR: {
    label: 'REGULAR',
    fontColor: 'text-green-success'
  },
  EVENT: {
    label: 'EVENT',
    fontColor: 'text-purple-secondary'
  },
  SUBSCRIPTION: {
    label: 'SUBSCRIPTION',
    fontColor: 'text-yellow-secondary'
  }
}

export const HEADERS: TableHeader[] = [
  {
    label: 'Customer',
    key: 'customer',
  },
  {
    label: 'Type',
    key: 'type',
  }
]
export const constructTableData = (data) => {
  const tableBody = data.map(booking => {
    const {
      customer,
      type
    } = booking
    return {
      value:
        {
          customer,
          type
        }
    }
  })
  const component = {
    customer: (v) => (renderCustomerComponent(v)),
    type: (v) => (<div>
      <p className={`font-bold text-small ${TYPE_TEXT_COLOR[v]?.fontColor}`}>{TYPE_TEXT_COLOR[v]?.label}</p>
    </div>)
  }
  return {
    data: tableBody,
    component
  }
}
export const META: TableSummarizeMeta = {
  startItem: 1,
  endItem: 10,
  totalItem: 10,
  pageNumber: 1,
  lastPage: 20
}
export const SORT: TableSort = {
  type: 'SERVER',
  handler: () => {},
};
